import { DealListItemResponse } from 'app/console-api';
import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import { MyDealsStatus } from 'app/components/common/deals-statuses/my-deals-status';
import { StyledChipsTag } from 'app/components/common/common-styles';
import React from 'react';
import { truncateString } from 'app/components/utils/measures-format';
import {DealTradeChip} from 'app/components/common/deal-trade-type/deal-trade-chip';

interface MyDealsListItemDetailsColumnProps {
  deal: DealListItemResponse;
}

export const MyDealsListItemDetailsColumn = (props: MyDealsListItemDetailsColumnProps) => {
  function getCategories() {
    if (!props.deal.categories) {
      return [];
    }
    let result: string[] = [];
    if (props.deal.categories.length > 3) {
      result = [...props.deal.categories.slice(0, 3), '…'];
    } else {
      result = [...props.deal.categories];
    }
    return result.map((cat) => truncateString(cat, 8));
  }

  const categories = getCategories();

  return (
    <FlexColumn gap={4}>
      <FlexRow gap={44}>
        <BodyText size={3} scale={'sm'} variation={'darkGray'}>
          Status:
        </BodyText>
        <FlexRow align={'center'} gap={4}>
          <MyDealsStatus
            withTable
            status={props.deal.dealStatus}
            type={props.deal.dealDetails.requestType}
            statusDescription={props.deal.statusDescription}
          />
        </FlexRow>
      </FlexRow>
      <FlexRow gap={18}>
        <BodyText size={3} scale={'sm'} variation={'darkGray'}>
          Deal Type:
        </BodyText>
        <FlexRow align={'center'} gap={4}>
          <DealTradeChip type={props.deal.dealDetails.tradeType}/>
        </FlexRow>
      </FlexRow>
      {categories.length > 0 && (
        <FlexRow gap={12}>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            Categories:
          </BodyText>
          <FlexRow gap={4} style={{ flexWrap: 'inherit' }}>
            {categories.map((cat, idx) => (
              <StyledChipsTag key={idx}>
                <BodyText size={3}>{cat}</BodyText>
              </StyledChipsTag>
            ))}
          </FlexRow>
        </FlexRow>
      )}
    </FlexColumn>
  );
};
